import { TFunction } from 'i18next';

import { SelectOption } from '@app/shared/types/common';
import {
  CurrentUser,
  CurrentUserProfile,
  CurrentUserProfileFormState,
  CurrentUserProfileUpdatePayload,
} from '@/app/store/slices/users/usersTypes';

export const sanitizeProfileForm = (
  user: CurrentUser | null | undefined,
  userProfile: CurrentUserProfile | null | undefined
): CurrentUserProfileFormState => ({
  telegramUsername: user?.telegramUsername ?? null,
  fullName: userProfile?.fullName ?? null,
  instagramTag: userProfile?.instagramTag ?? null,
  bio: userProfile?.bio ?? null,
  country: userProfile?.country ?? null,
  city: userProfile?.city ?? null,
  activitiesScope: userProfile?.activitiesScope ?? null,
  birthday: userProfile?.birthday ?? null,
  gender: userProfile?.gender ?? null,
  autoPurchase: user?.autoPurchase ?? true,
  feedPandaNtf: userProfile?.feedPandaNtf ?? true,
  isUserAgreementRead: userProfile?.isUserAgreementRead ?? true,
  isTutorialCompleted: userProfile?.isTutorialCompleted ?? true,
});

export const prepareProfileUpdatePayload = (
  profileForm: CurrentUserProfileFormState
): CurrentUserProfileUpdatePayload => ({
  fullName: profileForm.fullName,
  instagramTag: profileForm.instagramTag,
  bio: profileForm.bio,
  country: profileForm.country,
  city: profileForm.city,
  activitiesScope: profileForm.activitiesScope,
  // avatar?: string | null;
  birthday: profileForm.birthday,
  gender: profileForm.gender,
  // showSuperPower: profileForm.showSuperPower,
  feedPandaNtf: profileForm.feedPandaNtf,
  isUserAgreementRead: profileForm.isUserAgreementRead,
  isTutorialCompleted: profileForm.isTutorialCompleted,
});

export const getShortLabel = (translation: string, cutWords = 2) =>
  translation.split(' ').slice(0, -cutWords).join(' ');

export const mapToOptions = (obj: Record<string, string>): SelectOption[] =>
  Object.entries(obj).map(([value, label]) => ({ value, label }));

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
export const getSafeOptions = <T>(
  transform: (data: T) => SelectOption[],
  t: TFunction,
  key: string,
  ns?: string
): SelectOption[] => {
  const result = t(key, { returnObjects: true, ns });
  return typeof result === 'object' ? transform(result as T) : [];
};

export const getTags = (
  userCountry: string | undefined | null,
  userCity: string | undefined | null,
  userActivitiesScope: string | undefined | null,
  t: TFunction
) => {
  const countryTag = userCountry && t(`countries.${userCountry}`, { ns: 'countries' });
  const cityTag =
    userCountry && userCity && t(`cities.${userCountry}.${userCity}`, { ns: 'countries' });
  const activitiesTag = userActivitiesScope && t(`activities.${userActivitiesScope}`);

  return [countryTag, cityTag, activitiesTag].filter(
    (item): item is string => typeof item === 'string' && !!item.trim()
  );
};
